<div class="wrapper">
    <section class="container">

        <div class="row features justify-content-center">
            <section class="col-12 col-12-narrower feature text-start">

                <header class="major">
                    <h2 i18n>Umfassender Leitfaden zu Spring Framework und Spring Boot Annotationen</h2>
                </header>

                <h2 i18n>Umfassender Leitfaden zu Spring Framework und Spring Boot Annotationen</h2>
                <p i18n>Das <strong>Spring Framework</strong> und <strong>Spring Boot</strong> sind zentrale Säulen in
                    der Java-Entwicklung. Sie bieten eine Vielzahl von Annotationen, die es Entwicklern ermöglichen,
                    robuste und effiziente Anwendungen zu erstellen. Dieser Leitfaden bietet einen detaillierten
                    Überblick über die verschiedenen Annotationen und ihre Anwendungen.</p>

                <h3 i18n>Core Spring Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;Bean</strong>: Kennzeichnet eine Methode, die eine vom Spring IoC-Container
                        verwaltete Bean erzeugt.</li>
                    <li i18n><strong>&#64;Component</strong>: Markiert eine Klasse als Bean, die durch die Komponentensuche
                        gefunden und in den Anwendungskontext geladen wird.</li>
                    <li i18n><strong>&#64;Controller</strong>: Markiert eine Klasse als Bean für Spring MVC, die
                        Anfrage-Handler enthält.</li>
                    <li i18n><strong>&#64;RestController</strong>: Markiert eine Klasse als &#64;Controller-Bean und fügt
                        &#64;ResponseBody hinzu, um die Rückgabeergebnisse als Nachrichten zu serialisieren.</li>
                    <li i18n><strong>&#64;Configuration</strong>: Markiert eine Klasse als Java-Konfiguration, die Beans
                        definiert.</li>
                    <li i18n><strong>&#64;Service</strong>: Markiert eine Klasse als Bean, die üblicherweise Geschäftslogik
                        enthält.</li>
                    <li i18n><strong>&#64;Repository</strong>: Markiert eine Klasse als Bean für den Datenzugriff und fügt
                        eine automatische Umwandlung von SQLException in DataAccessExceptions hinzu.</li>
                </ul>

                <h3 i18n>Bean-Zustand Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;PostConstruct</strong>: Wird nach der Abhängigkeitsinjektion ausgeführt, um
                        Initialisierungen durchzuführen.</li>
                    <li i18n><strong>&#64;PreDestroy</strong>: Wird vor der Zerstörung des Beans ausgeführt, z. B. beim
                        Herunterfahren der Anwendung.</li>
                </ul>

                <h3 i18n>Konfigurationsannotationen</h3>
                <ul>
                    <li i18n><strong>&#64;Import</strong>: Importiert eine oder mehrere Java-Konfigurationsklassen.</li>
                    <li i18n><strong>&#64;PropertySource</strong>: Gibt den Ort der application.properties-Datei an, um
                        Schlüssel-Wert-Paare zur Spring-Umgebung hinzuzufügen.</li>
                    <li i18n><strong>&#64;Value</strong>: Injiziert Werte in annotierte Felder und Parameter.</li>
                    <li i18n><strong>&#64;ComponentScan</strong>: Konfiguriert die Komponentensuche für &#64;Component, &#64;Service
                        usw.</li>
                </ul>

                <h3 i18n>Bean-Eigenschaften Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;Lazy</strong>: Das annotierte Bean wird bei der ersten Verwendung verzögert
                        initialisiert.</li>
                    <li i18n><strong>&#64;Profile</strong>: Beans werden nur initialisiert, wenn die definierten Profile
                        aktiv sind.</li>
                    <li i18n><strong>&#64;Scope</strong>: Definiert den Erstellungsbereich des Beans, z. B. prototype,
                        singleton usw.</li>
                    <li i18n><strong>&#64;DependsOn</strong>: Definiert explizit eine Abhängigkeit zu anderen Beans in Bezug
                        auf die Erstellungsreihenfolge.</li>
                    <li i18n><strong>&#64;Order</strong>: Definiert die Sortierreihenfolge, wenn eine Liste von Beans
                        injiziert wird.</li>
                    <li i18n><strong>&#64;Primary</strong>: Das annotierte Bean wird ausgewählt, wenn mehrere Beans für die
                        Autowiring infrage kommen.</li>
                    <li i18n><strong>&#64;Conditional</strong>: Das annotierte Bean wird nur erstellt, wenn die Bedingungen
                        erfüllt sind.
                        <ul>
                            <li><strong>&#64;ConditionalOnBean</strong>: Die Bedingung wird erfüllt, wenn ein oder
                                mehrere spezifizierte Beans im Spring ApplicationContext vorhanden sind. Dies wird
                                häufig verwendet, um die Konfiguration basierend auf der Verfügbarkeit bestimmter
                                Beans anzupassen.</li>
                            <li><strong>&#64;ConditionalOnMissingBean</strong>: Im Gegensatz zu &#64;ConditionalOnBean wird
                                diese Bedingung erfüllt, wenn kein Bean des spezifizierten Typs im
                                ApplicationContext vorhanden ist. Dies ist nützlich, um sicherzustellen, dass eine
                                bestimmte Konfiguration nur dann geladen wird, wenn das erforderliche Bean fehlt.
                            </li>
                            <li><strong>&#64;ConditionalOnClass</strong>: Diese Annotation prüft die Anwesenheit einer
                                bestimmten Klasse oder Klassen im Klassenpfad. Ist die Klasse vorhanden, wird die
                                Bedingung erfüllt. Dies wird oft verwendet, um Auto-Konfigurationen basierend auf
                                der Verfügbarkeit von Klassen aus externen Bibliotheken zu steuern.</li>
                            <li><strong>&#64;ConditionalOnMissingClass</strong>: Das Gegenteil von &#64;ConditionalOnClass,
                                diese Bedingung ist erfüllt, wenn eine bestimmte Klasse nicht im Klassenpfad
                                vorhanden ist. Dies kann verwendet werden, um bestimmte Konfigurationen auszulassen,
                                wenn eine erforderliche Abhängigkeit fehlt.</li>
                            <li><strong>&#64;ConditionalOnProperty</strong>: Diese Annotation ermöglicht die
                                Konfiguration basierend auf dem Vorhandensein und dem Wert von Umgebungsvariablen
                                oder Properties. Es ist ein leistungsstarkes Werkzeug, um Konfigurationen in
                                verschiedenen Umgebungen zu steuern, wie z.B. Entwicklung, Test und Produktion.</li>
                            <li><strong>&#64;ConditionalOnMissingProperty</strong>: Ähnlich wie &#64;ConditionalOnProperty,
                                aber die Bedingung ist erfüllt, wenn eine bestimmte Eigenschaft (Property) nicht
                                definiert ist oder einen spezifischen, nicht wahren Wert hat. Dies wird verwendet,
                                um eine Konfiguration nur dann zu laden, wenn eine bestimmte Property nicht gesetzt
                                ist.</li>
                        </ul>
                    </li>

                </ul>

                <h3 i18n>Spring Boot-spezifische Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;SpringBootConfiguration</strong>: Kennzeichnet eine Spring
                        Boot-Anwendungskonfiguration.</li>
                    <li i18n><strong>&#64;EnableAutoConfiguration</strong>: Ermöglicht die automatische Konfiguration des
                        Anwendungskontexts basierend auf dem Klassenpfad.</li>
                    <li i18n><strong>&#64;ConfigurationProperties</strong>: Bietet externe Bindung von
                        Schlüssel-Wert-Eigenschaften.</li>
                    <li i18n><strong>&#64;ConstructorBinding</strong>: Bindet Eigenschaften mithilfe des Konstruktors anstatt
                        über Setter.</li>
                    <li i18n><strong>&#64;ConfigurationPropertiesScan</strong>: Ermöglicht die automatische Erkennung von
                        &#64;ConfigurationProperties-Klassen.</li>
                    <li i18n><strong>&#64;SpringBootApplication</strong>: Kombination aus &#64;SpringBootConfiguration,
                        &#64;EnableAutoConfiguration, &#64;ConfigurationPropertiesScan und &#64;ComponentScan.</li>
                    <li i18n><strong>&#64;EntityScan</strong>: Konfiguriert Basispakete zum Scannen von Entitätsklassen.</li>
                    <li i18n><strong>&#64;EnableJpaRepositories</strong>: Ermöglicht die automatische Konfiguration von
                        JPA-Repositories.</li>
                </ul>

                <h3 i18n>Bean-Injektion Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;Autowired</strong>: Beans werden in annotierte Setter, Felder oder
                        Konstruktorparameter injiziert.</li>
                    <li i18n><strong>&#64;Qualifier</strong>: Gibt den Namen eines Beans als zusätzliche Bedingung zur
                        Identifizierung eines eindeutigen Kandidaten für das Autowiring an.</li>
                </ul>

                <h3 i18n>Validierungsannotationen</h3>
                <ul>
                    <li i18n><strong>&#64;Valid</strong>: Kennzeichnet eine Eigenschaft, Methodenparameter oder Rückgabetyp
                        zur Validierung.</li>
                    <li i18n><strong>&#64;Validated</strong>: Variante von &#64;Valid, die die Validierung mehrerer Gruppen
                        ermöglicht.</li>
                </ul>

                <h3 i18n>Spring Boot Testannotationen</h3>
                <ul>
                    <li i18n><strong>&#64;SpringBootTest</strong>: Lädt den gesamten Anwendungskontext für Integrationstests.
                    </li>
                    <li i18n><strong>&#64;WebMvcTest</strong>: Lädt nur die Webschicht für Tests.</li>
                    <li i18n><strong>&#64;DataJpaTest</strong>: Lädt nur die JPA-Komponenten für Tests.</li>
                </ul>

                <h3 i18n>Transaktionsannotationen</h3>
                <ul>
                    <li i18n><strong>&#64;EnableTransactionManagement</strong>: Ermöglicht deklarative
                        Transaktionsverwaltung.</li>
                    <li i18n><strong>&#64;Transactional</strong>: Methoden, die mit dieser Annotation versehen sind, werden
                        in einer Transaktion ausgeführt.
                        <ul>
                            <li><strong>Methoden- und Klassenebene</strong>: Wenn es auf Klassenebene angewendet
                                wird, werden alle öffentlichen Methoden der Klasse transaktional.</li>
                            <li><strong>Transaktionsmanagement</strong>: Bei einer annotierten Methode startet
                                Spring eine neue Transaktion, bevor die Methode ausgeführt wird, und beendet die
                                Transaktion, nachdem die Methode ausgeführt wurde. Dies beinhaltet das Commit oder
                                Rollback der Transaktion, abhängig davon, ob die Ausführung erfolgreich war oder
                                eine Ausnahme ausgelöst wurde.</li>
                            <li><strong>Isolation und Propagation</strong>: Durch die Annotation können verschiedene
                                Transaktionseigenschaften wie Isolationsebene und Propagationsverhalten angepasst
                                werden. Die Isolationsebene definiert, wie Transaktionen voneinander isoliert sind,
                                und das Propagationsverhalten bestimmt, wie Transaktionen in Bezug auf bereits
                                laufende Transaktionen gehandhabt werden.</li>
                            <li><strong>Rollback-Regeln</strong>: Standardmäßig führt das Werfen einer
                                RuntimeException zu einem Rollback der Transaktion, während geprüfte Ausnahmen
                                (checked exceptions) dies nicht tun.</li>
                            <li><strong>Proxy-basiertes Verhalten</strong>: In Spring wird das
                                Transaktionsmanagement oft durch Proxies umgesetzt. Dies bedeutet, dass die
                                Transaktionslogik hinzugefügt wird, wenn ein Objekt durch einen Proxy gekapselt
                                wird. Dies hat Auswirkungen auf die Sichtbarkeit und das Verhalten von
                                transaktionalen Methoden innerhalb derselben Klasse.</li>
                            <li><strong>Datenquellen und Transaktionsmanager</strong>: Für JDBC, JPA, Hibernate oder
                                andere Persistenztechnologien können unterschiedliche Transaktionsmanager
                                konfiguriert werden.</li>
                            <li><strong>Spring Boot Konfiguration</strong>: In Spring Boot-Anwendungen wird das
                                Transaktionsmanagement oft automatisch konfiguriert. Dennoch kann die Konfiguration
                                durch Angabe eigener Transaktionsmanager oder Anpassung der
                                Transaktionseigenschaften weiter verfeinern werden.</li>
                        </ul>
                    </li>
                </ul>

                <h3 i18n>Spring JPA und Hibernate Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;Entity</strong>: Markiert eine Klasse als Entität in der Datenbank.</li>
                    <li i18n><strong>&#64;Table</strong>: Gibt die Tabelle in der Datenbank an, die der Entität entspricht.
                    </li>
                    <li i18n><strong>&#64;Id</strong>: Kennzeichnet ein Feld als Primärschlüssel der Entität.</li>
                    <li i18n><strong>&#64;GeneratedValue</strong>: Gibt die Strategie für die Erzeugung der
                        Primärschlüsselwerte an.</li>
                    <li i18n><strong>&#64;Column</strong>: Definiert spezifische Eigenschaften einer Spalte in der
                        Datenbanktabelle.</li>
                    <li i18n><strong>&#64;ManyToOne</strong>, <strong>&#64;OneToMany</strong>, <strong>&#64;OneToOne</strong>,
                        <strong>&#64;ManyToMany</strong>: Definieren die verschiedenen Arten von Beziehungen zwischen
                        Entitäten.
                    </li>
                    <li i18n><strong>&#64;JoinColumn</strong>: Gibt die Spalte für das Joining in Beziehungen an.</li>
                    <li i18n><strong>&#64;Embedded</strong> und <strong>&#64;Embeddable</strong>: Ermöglichen es, eine Klasse als
                        Teil einer anderen Entität zu verwenden.</li>
                    <li i18n><strong>&#64;MappedSuperclass</strong>: Ermöglicht das Erben von Eigenschaften in JPA-Entitäten.
                    </li>
                    <li i18n><strong>&#64;Transactional</strong>: Gibt an, dass eine Methode oder eine ganze Klasse in einem
                        Transaktionskontext ausgeführt werden soll.</li>
                </ul>

                <h3 i18n>Spring Security Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;EnableWebSecurity</strong>: Aktiviert die Web-Sicherheit in einer Spring-Anwendung.
                    </li>
                    <li i18n><strong>&#64;PreAuthorize</strong> und <strong>&#64;PostAuthorize</strong>: Definieren
                        Sicherheitsbedingungen vor bzw. nach der Ausführung einer Methode.</li>
                    <li i18n><strong>&#64;Secured</strong>: Schränkt den Zugriff auf Methoden basierend auf Rollen ein.</li>
                    <li i18n><strong>&#64;RolesAllowed</strong>: Gibt an, welche Sicherheitsrollen den Zugriff auf eine
                        Methode haben.</li>
                </ul>

                <h3 i18n>Spring AOP Annotationen</h3>
                <ul>
                    <li i18n><strong>&#64;Aspect</strong>: Markiert eine Klasse als Aspekt für Cross-Cutting-Concerns.</li>
                    <li i18n><strong>&#64;Before</strong>, <strong>&#64;After</strong>, <strong>&#64;AfterReturning</strong>,
                        <strong>&#64;AfterThrowing</strong>, <strong>&#64;Around</strong>: Definieren verschiedene Arten von
                        Ratschlägen (Advices) in AOP.
                    </li>
                    <li i18n><strong>&#64;Pointcut</strong>: Definiert einen Pointcut-Expression.</li>
                    <li i18n><strong>&#64;EnableAspectJAutoProxy</strong>: Ermöglicht die Unterstützung für Aspekte mit
                        automatischer Proxy-Erzeugung.</li>
                </ul>

            </section>
        </div>
    </section>

</div>